export default __webpack_public_path__ + "static/logo-white-a9fa21ff837f85f57ac9d60f01be8669.svg";